import { GlobalAxios } from "./../axios/axios-config";
import {
  INewTicketAutomationRuleEncMessage,
  ITicketAutomationRuleEncMessagesGetById,
} from "../models/automation-rule-enc-message";

const TICKET_SERVICE_WHATS_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/TicketAutomationRuleEncMessage/";

export const createTicketAutomationRuleEncMessage = (
  item: INewTicketAutomationRuleEncMessage
) => {
  return GlobalAxios.post(TICKET_SERVICE_WHATS_ROUTE, item);
};

export const getTicketAutomationRuleEncMessageById = (id: string) => {
  return GlobalAxios.get<ITicketAutomationRuleEncMessagesGetById>(
    TICKET_SERVICE_WHATS_ROUTE + id
  );
};

export const updateTicketAutomationRuleEncMessageById = ({
  item,
  id,
}: {
  item: INewTicketAutomationRuleEncMessage;
  id: string;
}) => {
  return GlobalAxios.put(TICKET_SERVICE_WHATS_ROUTE + id, item);
};
